export const notify = {
  '2001': '对不起，会议室已被关闭',
  '2002': '管理员已开启您的视频',
  '2003': '管理员已停止您的视频',
  '2004': '主持人已开启您的视频',
  '2005': '主持人已停止您的视频',
  '2006': '管理员已将您解除静音',
  '2007': '管理员已将您静音',
  '2008': '主持人已将您解除静音',
  '2009': '主持人已将您静音',
  '2010': '管理员已将您请出会议室',
  '2011': '管理员已锁定会议室，请等待管理员解锁'
}

// 代理服务器的错误码
export const proxyCode = {
  100: '连接会议服务器失败',
  4098: '服务器异常错误，请稍后重试', // 异常错误
  4099: '服务器异常错误，请稍后重试',
  4101: '用户未找到',
  4102: '验证失败',
  4103: '用户无权访问',
  4104: '参数错误',
  4105: '系统正在维护，暂停服务',
  4106: '访问人数过多，暂停服务',
  8449: '用户名或密码错误',
  8450: '会议室不存在', // 房间未找到
  8451: '会议室人数已满', // 房间已满
  8455: '服务器已满员', // 服务器已满员
  8456: '会议室用户已存在', // 用户已存在
  8457: '需要输入房间密码',
  8458: '管理员会议室已锁定, 请等待管理员解锁', // 房间已锁定
  8459: '会议室已过期', // 会议室已过期
  8460: '会议室已关闭', // 房间已关闭
  8461: '管理员拒绝用户进入锁定房间', // 主持人拒绝用户进入锁定房间的请求
  8462: '用户被列入黑名单，禁止进入锁定房间',
  8466: '产品服务已到期或余额不足，请及时续费', // 服务已到期或余额不足，请及时续费
  8467: '订购的产品服务被停用',
  8469: '该会议室号不存在，请重新输入',
  8470: '访问被拒绝，只允许以账号密码方式登录', // 访问被拒绝，只允许以用户名密码方式登录
  8473: '邀请码错误',
  8474: '邀请码过期',
  8476: '预约会议室未到时间(未开启)',
  8479: 'Token状态错误'
}

export const errCode = {
  '1001': '支持Chrome 88及以上或者Microsoft Edge 88及以上版本的浏览器',
  '1002': '登录paas失败',
  '1003': '获取代理服务器地址失败',
  '1004': '获取会议信息失败',
  '1005': '管理员才有关闭会议室的权限',
  '1006': '当前产品不支持，可联系销售进行咨询'
}

export const defaultResolutionList = [
  {
    key: 180,
    value: '320 x 180'
  },
  {
    key: 360,
    value: '640 x 360'
  },
  {
    key: 540,
    value: '960 x 540'
  },
  {
    key: 720,
    value: '1280 x 720'
  },
  {
    key: 1080,
    value: '1920 x 1080'
  }
]
export const RESOLUTIONMAP = {
  180: [320, 180],
  360: [640, 360],
  540: [960, 540],
  720: [1280, 720],
  1080: [1920, 1080]
}

// 布局类型
export const LAYOUT_TYPE = {
  DATA: 0, // 纯数据布局
  VIDEO: 1, // 纯视频布局
  DATA_VIDEO: 2 // 数据 + 视频布局
}
